import $ from 'jquery';
import {
    Swiper,
    Navigation,
    Pagination,
    Autoplay,
    Keyboard,
    // Scrollbar,
} from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination, Keyboard]);

const defaultBreakpoints = {
    4000: {
        slidesPerView: 3,
    },
    993: {
        slidesPerView: 3,
    },
    992: {
        slidesPerView: 2,
    },
    767: {
        slidesPerView: 2,
    },
    0: {
        slidesPerView: 1,
    },
}

const navigation = (el) => {
    const swiperClass = {
      nextEl: '.' + el + '-swiper__button--next',
      prevEl: '.' + el + '-swiper__button--prev',
    }
    return swiperClass;
}

$(window).load( function() {
    new Swiper( '.image_swiper', {
        slidesPerView: 3,
        observer: true,
        observeParents: true,
        spaceBetween: 30,
        breakpoints: defaultBreakpoints,
    });
    const imageSwiper = new Swiper( '.image-swiper', {
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        spaceBetween: 30,
        loop: 1,
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
        navigation: navigation('image'),
    });

    $('.image_swiper__image').on('click', function() {
        const count = $(this).data('image');
        imageSwiper.slideTo(count);
    })
});
